"use client";

import { joke, type JokeId } from "./Joke";

// Кнопка-заглушка с шутливым ответом — для серверных страниц
export default function JokeButton({ id, className, children }: { id: JokeId; className?: string; children: React.ReactNode }) {
  return (
    <button type="button" className={className} onClick={() => joke(id)}>
      {children}
    </button>
  );
}
